import { useTranslation } from '@thoughtspot/i18n';
import { UserAction, userActionTypeEnum, } from '@thoughtspot/metrics';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import { getCurrentOrgId } from '@thoughtspot/session-service';
import { uniqueId } from 'lodash';
import React from 'react';
import { Vertical } from "../../../utils/layouts";
import { DetailsConstant, TranslationKeys, } from '../constant';
import styles from './configuration-details.module.scss';
export const ConfigurationDetails = ({ configDetails, openConfigModalForEdit, onConfigReset, collectEvent, }) => {
    const { t } = useTranslation();
    const [configurationData, setConfigurationData] = React.useState([]);
    React.useEffect(() => {
        setConfigurationData(configDetails
            ? configDetails.map((configData) => [
                {
                    label: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_REPOSITORY_LABEL),
                    value: configData.repository_url ||
                        DetailsConstant.EMPTYDATA,
                },
                {
                    label: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_LABEL_USERNAME_LABEL),
                    value: configData.username || DetailsConstant.EMPTYDATA,
                },
                {
                    label: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_BRANCH_LABEL),
                    value: configData.commit_branch_name ||
                        DetailsConstant.EMPTYDATA,
                },
                {
                    label: t(TranslationKeys.VCS_ADMIN_CONFIG_MODAL_GUID_LABEL),
                    value: configData.configuration_branch_name ||
                        DetailsConstant.EMPTYDATA,
                },
                {
                    label: t(TranslationKeys.VCS_ADMIN_RIGHT_PANEL_DETAILS_VERSION_HISTORY_LABEL),
                    value: configData.enable_version_history
                        ? DetailsConstant.ENABLED
                        : DetailsConstant.DISABLED,
                },
            ])
            : []);
    }, [configDetails]);
    const renderHeader = () => {
        const handleEditClick = () => {
            openConfigModalForEdit(getCurrentOrgId().toString());
            collectEvent(new UserAction(userActionTypeEnum.VERSION_CONTROL_CONFIGURE_EDIT), {});
        };
        return (React.createElement("div", { className: styles.header },
            React.createElement(Typography, { variant: "h4", noMargin: true }, t(TranslationKeys.VCS_ADMIN_RIGHT_PANEL_DETAILS_HEADER_LABEL)),
            React.createElement("div", { className: styles.actionBtn },
                React.createElement(Button, { text: t(TranslationKeys.VCS_ADMIN_RIGHT_PANEL_EDITBTN_TEXT), type: "secondary", onClick: handleEditClick }))));
    };
    const renderDetails = (ind) => {
        return (React.createElement("div", { className: styles.detailsComponent }, configurationData[ind].map(data => (React.createElement("div", { key: uniqueId(data.label), className: styles.data },
            React.createElement(Typography, { variant: "p", className: styles.dataContent, noMargin: true }, data.label),
            React.createElement(Typography, { variant: "content-label-subhead", className: styles.dataContent, noMargin: true }, data.value))))));
    };
    const renderResetConfigurataionButton = (ind) => {
        const handleResetClick = () => {
            onConfigReset(getCurrentOrgId().toString());
            collectEvent(new UserAction(userActionTypeEnum.VERSION_CONTROL_CONFIGURE_RESET), {});
        };
        return (React.createElement(Link, { "datatest-id": "version-control-reset-btn", className: styles.resetConfiguration, onClick: handleResetClick }, t(TranslationKeys.VCS_ADMIN_RIGHT_PANEL_RESET_CONFIGURATION_LABEL)));
    };
    return (React.createElement(Vertical, { className: styles.configDetails }, configurationData.map((data, ind) => (React.createElement("div", { key: uniqueId('KEY_') },
        renderHeader(),
        renderDetails(ind),
        renderResetConfigurataionButton(ind))))));
};
//# sourceMappingURL=configuration-details.js.map